import React, { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Header } from "@/components/layout/Header";
import { useAuth } from "@/context/AuthContext";

// Provides page title/subtitle to Header via context.
export const LayoutHeadingContext = React.createContext(() => {});

export function AppLayout() {
  const { isAuthenticated, ready } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [heading, setHeading] = useState({ title: "Dashboard", subtitle: "" });

  if (!ready) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return (
    <div className="lux-grain flex min-h-screen bg-background">
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed((c) => !c)}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />
      <div className="flex min-w-0 flex-1 flex-col">
        <Header
          title={heading.title}
          subtitle={heading.subtitle}
          onOpenMobile={() => setMobileOpen(true)}
        />
        <main className="relative z-10 flex-1 px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
          <div className="mx-auto max-w-[1400px]">
            <LayoutHeadingContext.Provider value={setHeading}>
              <Outlet />
            </LayoutHeadingContext.Provider>
          </div>
        </main>
      </div>
    </div>
  );
}

// Hook pages use to set the header title.
export function usePageHeading(title, subtitle) {
  const setHeading = React.useContext(LayoutHeadingContext);
  React.useEffect(() => {
    setHeading({ title, subtitle });
  }, [title, subtitle, setHeading]);
}
